// Campus photo for /colleges/harvard-university: CC BY-SA 4.0, by chensiyuan, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASanders_theater_2009y.JPG), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/harvard-university/; credited under the photo.
const photo = {
    "slug": "harvard-university",
    "alt": "Memorial Hall, home of Sanders Theatre, at Harvard University in Cambridge, Massachusetts",
    "src": "/colleges/harvard-university/campus-1600.webp",
    "srcSmall": "/colleges/harvard-university/campus-800.webp",
    "srcMid": "/colleges/harvard-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/harvard-university/og.jpg",
    "title": "Sanders theater 2009y",
    "author": "chensiyuan",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASanders_theater_2009y.JPG",
    "read": "2026-09-30"
};

export default photo;
